// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__GBz0z","footer":"ModalFilter_footer__1ascq"};